module.exports = __webpack_public_path__ + "media/bootstrap-icons/twitter-53610bbd.svg";